import React from 'react'
import Header from '../../../../Components/Header'
import Pick from './Pick'
import { Helmet } from 'react-helmet'


const CreatepickNew = () => {
 

  return (
    <>
       <Helmet>
				<title>Picklist - Create</title>
			</Helmet>
       <Header />
       <div className="container-fluid maindiv pt-2">
        <Pick  />
       </div>
     </>
  )
}

export default CreatepickNew